import { Promotion } from '@components/promotion/models';
import { PromotionDocument } from '@services/elastic-search/models';
import { ElasticSearchResponse } from '@services/elastic-search/models/elastic-search-response';
import { LogsService } from '@services/logs';

export const generalPromotionSerializer = (
  response: ElasticSearchResponse<PromotionDocument>
): Promotion | undefined => {
  const promotionJson = response.hits.hits[0]?._source?.promotion?.[0];

  if (!promotionJson) {
    return undefined;
  }

  try {
    return JSON.parse(promotionJson) as Promotion;
  } catch (error) {
    LogsService.error(
      'generalPromotionSerializer',
      'Error during JSON conversion of the promotion',
      error,
      promotionJson
    );
    return undefined;
  }
};
